import React from 'react';
import { Helmet } from 'react-helmet';

const Resources = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <Helmet>
        <title>Recursos - Furgos Rio</title>
        <meta name="description" content="Planifica tu aventura perfecta en camper con nuestras herramientas y guías" />
      </Helmet>
      
      <div className="max-w-7xl mx-auto">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 sm:text-5xl md:text-6xl">
            Recursos
          </h1>
          <p className="mt-3 max-w-md mx-auto text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
            Planifica tu aventura perfecta en camper con nuestras herramientas y guías
          </p>
        </div>

        <div className="mt-12 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {/* Trip Planner Card */}
          <div className="bg-white overflow-hidden shadow-sm rounded-2xl border border-gray-100 hover:border-brand transition-all duration-300">
            <div className="px-4 py-5 sm:p-6">
              <h3 className="text-lg font-medium text-gray-900">Planificador de Rutas</h3>
              <p className="mt-1 text-sm text-gray-500">
                Obtén recomendaciones personalizadas de viaje según tus preferencias
              </p>
              <div className="mt-4">
                <button
                  onClick={() => window.location.href = '/resources/trip-planner'}
                  className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-xl shadow-sm text-white bg-brand hover:bg-brand/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand transition-all duration-300"
                >
                  Empezar a Planificar
                </button>
              </div>
            </div>
          </div>

          {/* More resource cards will be added here */}
        </div>
      </div>
    </div>
  );
};

export default Resources; 